// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-components-Messages-styles-__index__wrapper--2ypnH","page":"src-components-Messages-styles-__index__page--29C9y","narrowpage":"src-components-Messages-styles-__index__narrowpage--O2VzL","topsIndex":"src-components-Messages-styles-__index__topsIndex--K1vZm","main":"src-components-Messages-styles-__index__main--1r7Tl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Messages/styles/index.css
// module id = 1967
// module chunks = 0